<script>
  import {
    datagridStore,
    datagridFilterStore,
    datagridHistoryStore,
  } from "../../../stores/datagrid.store";
  import { hooksStore } from "../../../stores/hooks.store";

  import {
    vratKodFarbyPodlaTypu,
    vratKodIkonkyPodlaTypu,
  } from "../../../helpers/config";
  import Icon from "../../../components/Icon/Icon.svelte";
  import {
    historyBack,
    historyForward,
    tableHeaderTabClick,
    search,
    tableHeaderBreadcrumbsClick,
    ziskajExportDat,
    tlacTabulku,
    ziskajLvExport,
  } from "./datagrid.func";
  import { vratSubor } from "../../../api/file";
  import { onDestroy } from "svelte";
  import get from "get-value";

  let searchInput = "";
  let data = [];
  let unsubscribeDatagridStore = datagridStore.subscribe((store) => {
    data = get(store) || {};
  });
  let rozhodnutie_neexistuje_info = false;

  onDestroy(unsubscribeDatagridStore);

  let filter = {};
  let unsubscribeDatagridFilterStore = datagridFilterStore.subscribe(
    (store) => {
      filter = get(store) || {};
      searchInput = filter.post.search;
    }
  );

  onDestroy(unsubscribeDatagridFilterStore);

  let history = {};
  let unsubscribeDatagridHistoryStore = datagridHistoryStore.subscribe(
    (store) => {
      history = get(store) || {};
    }
  );

  onDestroy(unsubscribeDatagridHistoryStore);

  function zavriTabulku() {
    hooksStore.doAction("skryDatagrid");
  }

  let timer;

  const debounce = (v) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      search(v);
    }, 750);
  };

  let searchFormVisible = false;
  function showSearchForm() {
    searchFormVisible = !searchFormVisible;
    if (searchFormVisible) {
      setTimeout(() => {
        document.querySelector("#searchInput").focus();
      }, 100);
    }
  }

  async function getFile(url, filename) {
    await vratSubor(url, filename);
  }
</script>

<!-- Splitter header start  -->
<div class="splitter__header">
  {#if get(data, "allTabs")}
    <ul class="splitter__tab">
      {#each data.allTabs as tab, i}
        <li
          class:show={tab.hover}
          class="color__bg--{vratKodFarbyPodlaTypu(
            tab.name
          )} tooltip {tab.name === filter.get.tab ? 'active' : ''}"
          on:click={() =>
            tableHeaderTabClick({
              id: filter.get.id,
              type: filter.get.type,
              tab: tab.name,
              layer: filter.post.layer,
            })}
          on:mouseenter={() => (tab.hover = true)}
          on:mouseleave={() => (tab.hover = false)}
        >
          <span class="title color__text--{vratKodFarbyPodlaTypu(tab.name)}"
            >{tab.title || tab.name}</span
          >
          {#if tab.count}
            <span
              class="splitter__tab-count color__bg--{vratKodFarbyPodlaTypu(
                tab.name
              )}">{tab.count}</span
            >
          {/if}
          <Icon
            kod={vratKodIkonkyPodlaTypu(tab.name)}
            svg-color-class="color__text--{vratKodFarbyPodlaTypu(tab.name)}"
          />
        </li>
      {/each}
    </ul>
  {/if}

  <ul class="splitter__tab brCount">
    <li class="splitter__records">
      {#if get(data, "header")}
        <div class="splitter__records-street">
          {#each data.header.reverse() as link, i}
            <span
              class="color__text--{vratKodFarbyPodlaTypu(link.typ)}"
              on:click={() =>
                tableHeaderBreadcrumbsClick(
                  hooksStore.applyFilters("resetniANastavFilter", {
                    id: link.id,
                    type: link.typ,
                    tab: "default",
                  })
                )}
              >{link.nazov}
              {#if i < data.header.length - 1} → {/if}
            </span>
          {/each}
        </div>
      {/if}
    </li>
    <li>
      {#if get(data, "recordsTotal")}
        <div class="splitter__records-count">
          Záznamov: <strong>{get(data, "recordsTotal.count", 0)}</strong>
        </div>
      {/if}
    </li>
    {#if get(data, "download") && get(data, "type") !== "rozhodnutia"}
      <li
        on:click={getFile(
          get(data, "download.file"),
          get(data, "download.title")
        )}
      >
        <Icon
          kod={vratKodIkonkyPodlaTypu(get(data, "download.type"))}
          svg-color-class="color__text--{vratKodFarbyPodlaTypu(
            get(data, 'download.type')
          )}"
        />
      </li>
    {/if}
    {#if get(data, "type") === "rozhodnutia"}
      <li
        on:click={get(data, "download")
          ? getFile(get(data, "download.file"), get(data, "download.title"))
          : false}
        class:deactivate={get(data, "download", false) === false}
        class:show={rozhodnutie_neexistuje_info}
        on:mouseenter={() => (rozhodnutie_neexistuje_info = true)}
        on:mouseleave={() => (rozhodnutie_neexistuje_info = false)}
      >
        {#if get(data, "download", false) === false}
          <span class="title">Rozhodnutie nie je k dispozícii.</span>
        {/if}
        <Icon
          kod={vratKodIkonkyPodlaTypu("rozhodnutia")}
          svg-color-class="color__text--{vratKodFarbyPodlaTypu('rozhodnutia')}"
        />
      </li>
    {/if}
    {#if get(data, "type") === "lv"}
      <li on:click={() => ziskajLvExport(data.header[0].id)}>
        <Icon
          kod={vratKodIkonkyPodlaTypu("lv")}
          svg-color-class="color__text--{vratKodFarbyPodlaTypu('lv')}"
        />
      </li>
    {/if}
  </ul>

  <ul class="splitter__tab splitter__tab--controllers">
    <li>
      <span on:click={showSearchForm}>
        <Icon kod="002" />
      </span>

      <div class="input__group input__group--search" class:searchFormVisible>
        <div class="searchForm">
          <button
            type="submit"
            class="input__icon"
            on:click={() => {
              debounce("");
              searchInput = "";
              searchFormVisible = false;
            }}
          >
            <!-- JSON icon search start  -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon"
              viewBox="0 0 329.27 329.263"
            >
              <g transform="translate(0 -0.135)">
                <path
                  d="M21.34,329.4A21.332,21.332,0,0,1,6.258,292.984L292.848,6.39a21.329,21.329,0,0,1,30.164,30.164L36.422,323.148A21.231,21.231,0,0,1,21.34,329.4Zm0,0"
                  fill="currentColor"
                />
                <path
                  d="M307.93,329.4a21.273,21.273,0,0,1-15.082-6.25L6.258,36.554A21.329,21.329,0,0,1,36.422,6.39l286.59,286.594A21.332,21.332,0,0,1,307.93,329.4Zm0,0"
                  fill="currentColor"
                />
              </g>
            </svg>
            <!-- JSON icon search end  -->
          </button>
          <input
            type="text"
            placeholder="Vyhľadať"
            class="input"
            id="searchInput"
            bind:value={searchInput}
            on:keyup={({ target: { value } }) => debounce(value)}
          />
        </div>
      </div>
    </li>
    <li on:click={historyBack}>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 96.000000 96.000000"
        class="icon history {history.active > 0 ? 'active' : ''}"
      >
        <g transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)">
          <path
            d="M235 670 l-130 -130 131 -131 130 -130 25 20 24 20 -95 95 -95 96
                218 0 c199 0 221 -2 257 -20 45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130
                -21 -11 -46 -20 -55 -20 -10 0 -15 -10 -15 -31 0 -31 1 -31 37 -24 52 10 85
                28 121 69 68 78 68 194 -1 273 -59 67 -84 73 -337 73 l-225 0 95 95 c93 93 94
                94 75 115 -10 11 -21 20 -24 20 -4 0 -65 -59 -136 -130z"
          />
        </g>
      </svg>
    </li>
    <li on:click={historyForward}>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 96.000000 96.000000"
        class="icon history {history.active < history.data.length - 1
          ? 'active'
          : ''}"
      >
        <g transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)">
          <path
            d="M565 780 c-19 -21 -18 -22 75 -115 l95 -95 -225 0 c-198 0 -230 -3
              -265 -19 -168 -78 -164 -314 7 -385 59 -25 78 -21 78 14 0 20 -5 30 -15 30 -9
              0 -34 9 -55 20 -45 23 -80 80 -80 130 0 50 35 107 80 130 36 18 58 20 257 20
              l218 0 -95 -96 -95 -95 24 -20 25 -20 130 130 131 131 -130 130 c-71 71 -132
              130 -136 130 -3 0 -14 -9 -24 -20z"
          />
        </g>
      </svg>
    </li>
    <li on:click={() => ziskajExportDat("csv")}>
      <Icon kod="042" />
    </li>
    <li on:click={tlacTabulku}>
      <Icon kod="043" svg-fill="#144672" />
    </li>

    <li on:click={zavriTabulku}>
      <!-- JSON icon Close start -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="icon"
        viewBox="0 0 329.27 329.263"
      >
        <g transform="translate(0 -0.135)">
          <path
            d="M21.34,329.4A21.332,21.332,0,0,1,6.258,292.984L292.848,6.39a21.329,21.329,0,0,1,30.164,30.164L36.422,323.148A21.231,21.231,0,0,1,21.34,329.4Zm0,0"
            fill="#ff8d8d"
          />
          <path
            d="M307.93,329.4a21.273,21.273,0,0,1-15.082-6.25L6.258,36.554A21.329,21.329,0,0,1,36.422,6.39l286.59,286.594A21.332,21.332,0,0,1,307.93,329.4Zm0,0"
            fill="#ff8d8d"
          />
        </g>
      </svg>
      <!-- JSON icon Close end -->
    </li>
  </ul>
</div>

<!-- Splitter header end  -->
<style lang="scss">
  .icon {
    &.history {
      color: #ccc;

      &.active {
        color: #000;
      }
    }
  }

  .input__group {
    display: none;
    position: absolute;
    right: 0;
    bottom: 35px;
    z-index: 9;
    border: 1px solid #e4e4e4;

    &.searchFormVisible {
      display: block;
    }
  }
  .input__group--search {
    .input {
      border-bottom: none;
    }
  }

  .brCount {
    flex-grow: 1;
    justify-content: space-between;

    li {
      border: none;
    }
  }
  .title {
    position: absolute;
    background: #f4f4f4;
    padding: 5px 10px 10px;
    width: 160px;
    z-index: 2;
    bottom: 100%;
    left: -1px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: none;
    font-size: 0.7rem;
    line-height: 16px;
    text-align: center;
    display: none;
  }
  li.show .title {
    display: block;
  }
  li:hover:not(.active) {
    background-color: #f4f4f4;
  }
</style>
